import React from 'react';

type ComponentPromise<T> = Promise<{ default: React.ComponentType<T> }>;

// a function to retry loading a chunk to avoid chunk load error for out of date code
function retry<T>(componentImport: () => ComponentPromise<T>, name = 'lazy') {
	return new Promise((resolve, reject) => {
		// check if the window has already been refreshed
		const hasRefreshed = JSON.parse(window.sessionStorage.getItem(`retry-${name}-refreshed`) || 'false');
		// try to import the component
		componentImport()
			.then(component => {
				window.sessionStorage.setItem(`retry-${name}-refreshed`, 'false'); // success so reset the refresh
				resolve(component);
			})
			.catch(error => {
				if (!hasRefreshed) {
					// not been refreshed yet
					window.sessionStorage.setItem(`retry-${name}-refreshed`, 'true'); // we are now going to refresh
					window.location.reload(); // refresh the page
				} else reject(error); // Default error behaviour as already tried refresh
			});
	}) as ComponentPromise<T>;
}

export default function lazyRetry<T>(
	componentImport: () => ComponentPromise<T>,
	name?: string
): React.LazyExoticComponent<React.ComponentType<T>> {
	return React.lazy(() => retry<T>(componentImport, name));
}
